import { render } from "./userTags.vue?vue&type=template&id=b0079e9e"
import script from "./userTags.vue?vue&type=script&lang=js"
export * from "./userTags.vue?vue&type=script&lang=js"

import "./userTags.vue?vue&type=style&index=0&id=b0079e9e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__